import { render, staticRenderFns } from "./InsertEmailDialogForCasual.vue?vue&type=template&id=167fd53b&scoped=true&"
import script from "./InsertEmailDialogForCasual.vue?vue&type=script&lang=js&"
export * from "./InsertEmailDialogForCasual.vue?vue&type=script&lang=js&"
import style0 from "./InsertEmailDialogForCasual.vue?vue&type=style&index=0&id=167fd53b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167fd53b",
  null
  
)

export default component.exports